import { actionTypes } from './actions';
import { COUNTRY } from '../../constants/location';

export const initialState = {
  ip: null,
  country: COUNTRY.VN,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_LOCATION: {
      const { ip, country } = action;
      return {
        ...state,
        ip,
        country,
      };
    }

    default:
      return state;
  }
};

export default locationReducer;
